/* eslint-disable no-undef */
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCarousel from 'vue-carousel'
import VueCharts from 'vue-charts'
import axios from 'axios'
import VTooltip from 'v-tooltip'
import {PiniaVuePlugin} from 'pinia'

Vue.use(VueRouter)
Vue.use(VueCarousel)
Vue.use(VueCharts)
Vue.use(VTooltip)
Vue.use(PiniaVuePlugin)
Vue.config.productionTip = true

axios.interceptors.request.use((config) => {
  const hasToken = !!localStorage.auth_token

  if (hasToken) {
    config.headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': 'Bearer ' + localStorage.auth_token
    }
  }
  return config
}, (error) => {
  return Promise.reject(error)
})
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.baseURL = process.env.API_URL

window.events = new Vue()

/**
 * Emits the flash event for the flash message component to handle
 * @param {string} message api response message to flash
 * @param {string} css depending on http response from server ie. 200/400 use css style of choice to depict success/not
 * @param {boolean} hideCloseBtn flag to hide close btn - translating to flash message persisting on page and not
 * disappearing on settimeout expiry
 * @returns {void}
 */
window.flash = (message, css, hideCloseBtn = false) => {
  window.events.$emit('flash', message, css, hideCloseBtn)
}

/**
 * Triggers the closure of a flash message
 * @returns {void}
 */
window.closeFlash = () => {
  window.events.$emit('closeFlash')
}

/**
 * Emits the modal event for the modal component to handle
 * @param {object} props an object of properties for modal to use for dynamic rendering of modal elements
 * @returns {void}
 */
window.modal = (props) => {
  window.events.$emit('modal', props)
}

window.modalIsActive = false

document.addEventListener('DOMContentLoaded', function () {
  /* Start: Bulma Dropdown */
  document.addEventListener('click', function (event) {
    const bulmaDd = event.target.closest('.c-dropdown')
    if (!bulmaDd) {
      document.querySelectorAll('.c-dropdown').forEach(function ($el) {
        $el.classList.remove('is-active')
      })
    } else if (/* !event.target.classList.contains('tooltip-icon') && */ !event.target.classList.contains('c-radio')) {
      bulmaDd.classList.toggle('is-active')
      document.querySelectorAll('.c-dropdown').forEach(function ($el) {
        if ($el !== bulmaDd) {
          $el.classList.remove('is-active')
        }
      })
    }
  })
  /* End: Bulma Dropdown */
})



// WEBPACK FOOTER //
// ./src/bootstrap.js